import { storyblokEditable } from "gatsby-source-storyblok"

import PolicyCard from "../../../V2/Cards/PolicyCard"

import React from "react"

const StoryblokPolicyCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.PolicyCard>) => {
  if (!blok.policyConfig.content) return null

  const policyConfig = blok.policyConfig.content

  return (
    <PolicyCard
      title={policyConfig.title}
      description={policyConfig.description}
      thumbnailUrl={policyConfig.thumbnail?.filename}
      thumbnailAlt={policyConfig.thumbnail?.alt}
      policyUrl={policyConfig.document?.filename}
      backgroundColor={blok.backgroundColor}
      size={blok.size}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokPolicyCard
